import React from 'react';
import { FormCheckbox, FormGroup, FormInput, FormTextarea, ModalBody } from 'shards-react';

interface ModalEditBodyProps {
  labelOrder: string;
  labelMessage: string;
  labelDraft: string;
  order: number;
  message: string;
  checked: boolean;
  invalidOrder: boolean;
  invalidMessage: boolean;
  onChangeOrder: (event: React.ChangeEvent<{ value: number }>) => void;
  onChangeMessage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeDraft: () => void;
}

const ModalEditTradingCompanyInformation = ({
  labelOrder,
  labelMessage,
  labelDraft,
  order,
  message,
  checked,
  invalidOrder,
  invalidMessage,
  onChangeOrder,
  onChangeMessage,
  onChangeDraft,
}: ModalEditBodyProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================
  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(isUniqueCode);
  // }, [isUniqueCode]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalBody>
      <FormGroup>
        <label htmlFor="order">{labelOrder}</label>
        <FormInput id="order" type="number" className="mb-3" value={order} invalid={invalidOrder} onChange={onChangeOrder} />
      </FormGroup>
      <FormGroup>
        <label htmlFor="text">{labelMessage}</label>
        <FormTextarea id="text" className="mb-3" rows={4} value={message} invalid={invalidMessage} onChange={onChangeMessage} />
      </FormGroup>
      <FormCheckbox checked={checked} onChange={onChangeDraft}>
        {labelDraft}
      </FormCheckbox>
    </ModalBody>
  );
};

export default ModalEditTradingCompanyInformation;
